const columns = [
  {
    alignHeader: 'left',
    alignColumns: 'left',
    key: 'contractor',
    sortMethod: 'text',
    width: 40,
  },
  {
    alignHeader: 'left',
    alignColumns: 'left',
    key: 'project',
    sortMethod: 'text',
    width: 40,
  },
  {
    alignHeader: 'left',
    alignColumns: 'left',
    key: 'status',
    sortMethod: 'text',
    width: 15,
  },
];

export default columns;
